module.exports = __webpack_public_path__ + "img/about-values-04.jpg?0d8016c547e54d52c0f2c702047f52d9";